var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContent"},[_c('section',{staticClass:"termine windowFrame"}),_vm._v(" "),_c('section',{staticClass:"haesusliches windowFrame"}),_vm._v(" "),_c('section',{staticClass:"atmosphaere windowFrame"}),_vm._v(" "),_c('section',{staticClass:"vertrauen windowFrame"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-138e7ba5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bigSection.vue
// module id = 49
// module chunks = 0